import React, { Fragment, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'reactstrap';
import { setSidebarToggle } from '~/redux/actions';
import LeftSidebar from './LeftSidebar';
import RightSidebar from './RightSidebar';

function LayoutPeta({ children, title }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const { sidebarToggle } = useSelector((state) => state.Map);

    const dispatch = useDispatch();
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

    return (
        <Fragment>
            <Helmet title={title} />
            <div className="d-flex" style={{ height: '100vh', overflow: 'hidden' }}>
                {/* LEFT SIDEBAR */}
                <div
                    style={{
                        maxWidth: 400,
                        maxHeight: 'calc(100vh - 56px)',
                        position: 'relative',
                    }}>
                    <button
                        className="btn-sidebar-maps"
                        id="tooltipSidebar"
                        onClick={() => dispatch(setSidebarToggle(!sidebarToggle))}>
                        {sidebarToggle ? (
                            <i className="mdi mdi-chevron-left icon-sidebar-maps" />
                        ) : (
                            <i className="mdi mdi-chevron-right icon-sidebar-maps" />
                        )}
                    </button>
                    <Tooltip placement="right" target="tooltipSidebar" isOpen={tooltipOpen} toggle={toggleTooltip}>
                        {sidebarToggle ? 'Ciutkan panel samping' : 'Luaskan panel samping'}
                    </Tooltip>
                    <div
                        id="leftSidebar"
                        className="leftpanel-maps"
                        style={{
                            maxWidth: 400,
                            marginLeft: sidebarToggle ? 0 : -400,
                        }}
                    />
                </div>

                <div className="flex-fill w-100">{children}</div>

                {/* RIGHT SIDEBAR */}
                <div id="rightSidebar" style={{ maxWidth: 400, height: 'calc(100vh - 56px)' }} />
            </div>
        </Fragment>
    );
}

LayoutPeta.LeftSidebar = LeftSidebar;
LayoutPeta.RightSidebar = RightSidebar;

export default LayoutPeta;
